<template>

    <div v-for="(score, indexS) in data" :key="indexS">
        <h4>
            <a-row>
                <a-col span="8">
                    {{indexS+1}}.{{score.name}}
                </a-col>
                <a-col span="15" v-if="score.score">
                    <a-rate v-model:value="score.score" :count="10" disabled />
                    {{score.score}}
                </a-col>
            </a-row>
        </h4>
        <p v-if="score.suggestion">
            <simple-code :data="score.suggestion"/>
        </p>
    </div>
    <span v-if="data.length === 0"> No tools</span>
</template>

<script>

    import SimpleCode from "./SimpleCode";
    export default {
        name: "ToolVue",
        components: {SimpleCode},
        props: ['data'],
    }
</script>

<style>

</style>
